import { render, staticRenderFns } from "./data39.vue?vue&type=template&id=4f543bee&scoped=true"
import script from "./data39.vue?vue&type=script&lang=js"
export * from "./data39.vue?vue&type=script&lang=js"
import style1 from "./data39.vue?vue&type=style&index=1&id=4f543bee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f543bee",
  null
  
)

export default component.exports